import { createDboxPluginStoreConfig } from "../dboxstore/dboxstore";

export const createDboxConfig = ({
  // storeNamesPace = 'CatalogStore',
  // detailsAction = 'ProductDetails',
  // detailsGetterKey = 'productDetails',
  // itemsKey = 'costs',
  // primaryKeyValue = '12345',

  storeNamesPace = 'CatalogStore',
  detailsAction = 'ProductDetails',
  detailsGetterKey = 'productDetails',
  dataKey = 'costs',
  primaryKeyValue = '12345',
  
  externalTable = 'release',
}) => {
  return {
    storeNamesPace,
    detailsAction,
    detailsGetterKey,
    dataKey,
    primaryKeyValue,
    externalTable,
  }
}

